"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerSupportType;
(function (CustomerSupportType) {
    /**
     * Includes priority chat support.
     */
    CustomerSupportType["Priority"] = "priority";
    /**
     * Includes priority chat and phone support.
     */
    CustomerSupportType["PriorityAll"] = "priorityAll";
    /**
     * Includes chat support.
     */
    CustomerSupportType["Standard"] = "standard";
})(CustomerSupportType || (CustomerSupportType = {}));
exports.default = CustomerSupportType;
